import {
  Home,
  Lightbulb,
  GraduationCap,
  Gamepad2,
  UtensilsCrossed,
  Gift,
  ShoppingBasket,
  Stethoscope,
  Pizza,
  CircleEllipsis,
  Sandwich,
  ShoppingCart,
  Dumbbell,
  Car,
  Plane,
  Beer,
  Receipt,
  Banknote,
  type LucideIcon,
} from 'lucide-react';

/**
 * Maps Ionicons names (used in mobile app / DB) to Lucide icons (web).
 */
const IONICON_TO_LUCIDE: Record<string, LucideIcon> = {
  'home': Home,
  'bulb': Lightbulb,
  'school': GraduationCap,
  'game-controller': Gamepad2,
  'restaurant': UtensilsCrossed,
  'gift': Gift,
  'basket': ShoppingBasket,
  'medkit': Stethoscope,
  'pizza': Pizza,
  'ellipsis-horizontal-circle': CircleEllipsis,
  'fast-food': Sandwich,
  'cart': ShoppingCart,
  'fitness': Dumbbell,
  'car': Car,
  'airplane': Plane,
  'beer': Beer,
  'receipt': Receipt,
  'cash': Banknote,
};

interface CategoryIconProps {
  icon?: string | null;
  color?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: { container: 'h-8 w-8', icon: 'h-4 w-4' },
  md: { container: 'h-10 w-10', icon: 'h-5 w-5' },
  lg: { container: 'h-12 w-12', icon: 'h-6 w-6' },
};

export function CategoryIcon({ icon, color, size = 'md', className = '' }: CategoryIconProps) {
  const IconComponent: LucideIcon = (icon ? IONICON_TO_LUCIDE[icon] : undefined) ?? Receipt;
  const iconColor = color ?? '#6B7280';
  const sizes = sizeMap[size];

  return (
    <div
      className={`flex items-center justify-center rounded-full shrink-0 ${sizes.container} ${className}`}
      style={{
        backgroundColor: `${iconColor}20`,
        color: iconColor,
      }}
    >
      <IconComponent className={sizes.icon} />
    </div>
  );
}
